import { useAccount, useReadContract } from "wagmi";
import useDappConfig from "./useDappConfig";
import { arbitrum, blast } from "viem/chains";

const useDepositFee = () => {
  const { chain } = useAccount();
  const { config } = useDappConfig();
  const { data } = useReadContract({
    ...config.interactionPools.lrtDepositPool,
    functionName: "feeBps",
    query: {
      enabled: chain && (chain.id === blast.id || chain.id === arbitrum.id),
    },
  });

  return data
    ? {
        value: data as bigint,
        formatted: parseFloat((Number(data) / (100 * 100)).toString()),
      }
    : { value: 0n, formatted: 0 };
};

export default useDepositFee;
